module.exports = __webpack_public_path__ + "2c2a2778066e1b8bec34ce111740bcf3.png";